import {
  CREATE_CATEGORIES,
  CREATE_CARS,
  GETALL_CARS,
  GETALL_CATEGORIES,
  UPDATE_CARS,
  DELETE_CARS,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  GETCARBYID,
  ERROR
} from "../type";

const inital = {
  createCar: [],
  createCategory: [],
  updateCategory: [],
  deleteCategory: [],
  GetallCar: [],
  GetcarbyId:[],
  GetAllCategory: [],
  UpdateCar: [],
  DeleteCar: [],
  loading: true,
  error:[],
};
const CarReduser = (state = inital, action) => {
  switch (action.type) {
    case CREATE_CATEGORIES:
      return {
        GetAllCategory:state.GetAllCategory,
        createCategory: action.payload,
        loading: false,
      };
    case UPDATE_CATEGORY:
      return {
            GetAllCategory:state.GetAllCategory,
        updateCategory: action.payload,
        loading: false,
      };
    case DELETE_CATEGORY:
      return {
            GetAllCategory:state.GetAllCategory,
        deleteCategory: action.payload,
        loading: false,
      };
    case CREATE_CARS:
      return {
        GetallCar:state.GetallCar,
        createCar: action.payload,
        loading: false,
      };
    case DELETE_CARS:
      return {
        GetallCar:state.GetallCar,
        DeleteCar: action.payload,
        loading: false,
      };
    case GETALL_CARS:
      return {
        ...state,
        GetallCar: action.payload,
      };
      case GETCARBYID:
        return {
          ...state,
          GetcarbyId: action.payload,
        };
    case GETALL_CATEGORIES:
      return {
        ...state,
        GetAllCategory: action.payload,
      };
    case UPDATE_CARS:
      return {
        GetallCar:state.GetallCar,
        UpdateCar: action.payload,
        loading: false,
      };
      case ERROR:
        return {
          loading: false,
          error: action.payload,
        };
    default:
      return state;
  }
};
export default CarReduser;
